import { useFeatureToggles } from '@xmcloud/hooks';
import { useFeature } from '../../../feature-flag/features';

export const useCreateProjectV3 = () => {
	const { useDecoupledDeployments } = useFeatureToggles();
	const createProjectV3 = useFeature('CreateProjectV3');
	const enableCreateProjectV3 = createProjectV3 && useDecoupledDeployments;
	return { enableCreateProjectV3 };
};
